import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ErrorService } from 'src/app/services/Dossier/error.service';
import { PayslipCollection } from 'src/app/classes/dossier/payslip-collection';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-upload-payslip',
    templateUrl: './upload-payslip.component.html',
    styleUrls: ['./upload-payslip.component.scss']
})
export class UploadPayslipComponent implements OnInit {
    @Output() errorHandlingEvent = new EventEmitter<any>();
    @Output() toCobhamEvent = new EventEmitter<any>();
    @Output() isLoadingEvent = new EventEmitter<any>();
    @Output() isNextButtonEvent = new EventEmitter<any>();
    @Output() hasAtLeastOnePayslipEvent = new EventEmitter<any>();
    @Output() updatePayslipsEvent = new EventEmitter<any>();
    @Output() setButtonsToPauseCobham = new EventEmitter<any>();

    @Input() isSimulation: boolean;
    @Input() dateParams;
    @Input() dossierId;
    @Input() payslipsAreDeletable = false;
    @Input() missingBS = false;
    @Input() delegationToken = false;

    oldDateParams;
    oldDossierId;
    dossier: any;
    
    isLoading = false;
    gifs = [];
    
    payslipCollection: PayslipCollection;
    payslipsMonthsLength: number = 12;
    clickedPeriod: number;
    
    @Input() reloadEvent: Observable<any>;
    reloadSubscription: Subscription;
    numberFilesUploaded: number;
    numberFilesToUpload: number;
    promises: any = [];
    sizemaxFile: number = 4194304; // 4Mo par défaut
    
    errorAbbyy: boolean = false;

    ngOnDestroy() {
        if (this.reloadEvent) {
            this.reloadSubscription.unsubscribe();
        }
    }

    constructor(
        private appService: AppService,
        private errorService: ErrorService,
        private cdf: ChangeDetectorRef,
        ) {}

    ngOnInit() {
        this.payslipCollection = new PayslipCollection([]);
        this.loadParameters();
        if (this.reloadEvent) {
            this.reloadSubscription = this.reloadEvent.subscribe(() => this.loadParameters());
        }
    }

    ngDoCheck() {
        if (this.dateParams !== this.oldDateParams) {
            this.oldDateParams = this.dateParams;
            this.loadParameters();
        }
    }

    async loadParameters() {
        this.loadGifs("assets/image/cob-gif-attente.gif", "assets/image/upload-gif-attente.gif");
        this.oldDateParams = this.dateParams;
        this.oldDossierId = this.dossierId;

        if (this.dateParams != null && !this.isLoading) {
            this.isLoading = true;

            if (this.dateParams.startDatePeriod && this.dateParams.endDatePeriod) {
                this.payslipCollection.setStartDatePeriod(this.dateParams.startDatePeriod);
                this.payslipCollection.setEndDatePeriod(this.dateParams.endDatePeriod);
    
                let differenceMonths = 
                    this.getDifferenceInMonths(
                        this.payslipCollection.startDatePeriod, 
                        this.payslipCollection.endDatePeriod);
    
                this.payslipsMonthsLength = differenceMonths + 1;
                this.payslipCollection.monthsLengthPeriod = differenceMonths + 1;
            }

            await new Promise((resolve) => {
                this.appService.getDossierById(this.dossierId).subscribe((response) => {
                    this.dossier = response.result.datas[0];
                    // console.log("avant =>", Array.from(this.payslips), Array.from(this.payslips).map((payslip) => (payslip.data)));
                    this.setNewerPayslips(response.result.datas[0]);
                    this.payslipCollection.setPayslips(
                        response.result.datas[0]["bulletinSalaire"], 
                        this.payslipsAreDeletable);
                    resolve(true);
                })
            })

            this.changeNextButtonIfPayslipsAreEnough();
            this.sendEventIfOnePayslipUploaded();
            this.isLoading = false;
            this.updatePayslipsEvent.emit(this.payslipCollection);
        }
    };

    uploadFile(event) {
        if (event) {
            if (this.promises && this.promises.length > 0) {
                return
            }
            this.emitEvent("loading", true);
            this.numberFilesToUpload = 0;
            this.numberFilesUploaded = 0;
            this.promises = [];
            let reco = [];
            for (let i=0; i<event.length; i++) {
                this.numberFilesToUpload = event.length;
                const element = event[i];
                reco[i] = {
                    nom: element.name,
                    failed: false,
                }
        
                if (element.size < this.sizemaxFile) {
                    if (this.clickedPeriod) {
                        this.payslipCollection.payslips.map(payslip => {
                            if (payslip.yearAndMonth == this.clickedPeriod) {
                                payslip.data = reco[i];
                                payslip.isLoading = true;
                            }
                        })
                    } else {
                        this.payslipCollection.addLoadingPayslip(reco[i]);
                    }
                    this.promises.push(
                        this.appService.uploadDocument(element, this.dossierId).toPromise().then(res => {
                            reco[i].url = res.url ? res.url : "";
                            this.numberFilesUploaded++;
                            if (res.error_reco) {
                                if (res.error_reco == "Le service d'Ocr (ABBY) est momentanement indisponible.")
                                    this.errorAbbyy = true
                                reco[i].state = res.error_reco;
                                reco[i].failed = true;
                            }
                            if (i === event.length && this.errorAbbyy) {
                                this.errorService.sendMailAbbyyError();
                            }
                        })
                    )
                } else {
                    reco[i].erreur = "Taille du fichier trop élevée";
                    this.payslipCollection.addNotSavedPayslip(reco[i]);
                    reco.splice(i,1) 
                }
            }
            Promise.all(this.promises).then((value) => {
                this.appService.getDossierById(this.dossier.id).subscribe((res) => {
                    if (res.result.error && res.result.code) {
                        this.resetLoadingParameters();
                        let errorHandlingMessage = this.errorService.errorHandling(res.result);
                        if (errorHandlingMessage) {
                            this.emitEvent('error', errorHandlingMessage);
                        }
                    } else {
                        this.dossier = res.result.datas[0];
                        this.afterDownloadSuccess(reco);
                    }
                });
            }).catch((error) => {
                this.resetLoadingParameters();
            })
        }
    }

    resetLoadingParameters() {
        this.emitEvent("loading", false);
        this.clickedPeriod = 0;
    }

    changeNextButtonIfPayslipsAreEnough() {
        if (this.payslipCollection.consecutivePayslips.length 
            === this.payslipsMonthsLength) {
            this.emitEvent("nextButton", true);
        } else {
            this.emitEvent("nextButton", false);
        }
    }

    setNewerPayslips(dossier) {
        let datecobham = dossier.datecobham ? new Date(dossier.datecobham) : Date.now();
        dossier.bulletinSalaire = dossier.bulletinSalaire
            .sort(a => (a.typepage == "P" ? 1 : -1))
            .sort((a, b) => (a.datedebutbs > b.datedebutbs ? 1 : -1))
            .filter((bulletin) => {
                bulletin.new = datecobham < new Date(bulletin.datecreation); 
                return [bulletin]; 
            });
    }

    afterDownloadSuccess(files){
        let collection = this.payslipCollection;
        let payslipsToAdd = [];
        if (this.errorAbbyy)
            console.log("%c ErroR Abbyy ==> " + this.errorAbbyy, "color:red;")
            
        this.setNewerPayslips(this.dossier);
        collection.setPayslips(
            this.dossier.bulletinSalaire, this.payslipsAreDeletable);
        collection.setLongestConsecutivePayslips();

        this.changeNextButtonIfPayslipsAreEnough();
        this.sendEventIfOnePayslipUploaded();
        this.resetLoadingParameters();
        this.promises = [];

        files.forEach(file => {
            if (file.failed) {
                file.erreur = file.state;
                this.payslipCollection.addNotSavedPayslip(file);
            } else if (file.erreur) {
                collection.addPayslip(file);
            }
        });
        if (this.errorAbbyy) {
            this.appService.sendMailErrorAdmin(this.dossier.id).subscribe(res => {
                this.errorAbbyy = false;
            })
        }
        this.updateStateDossier();
        this.cdf.detectChanges();
        this.updatePayslipsEvent.emit(this.payslipCollection);
    }

    removeNotSavedPayslip(payslipRemoved) {
        this.payslipCollection.removeNotSavedPayslip(payslipRemoved);
    }

    removePayslip(payslipRemoved) {
        this.payslipCollection.removePayslip(payslipRemoved);
        this.changeNextButtonIfPayslipsAreEnough();
        this.sendEventIfOnePayslipUploaded();

        this.updatePayslipsEvent.emit(this.payslipCollection);
    }

    removeErrorPayslip(payslipRemoved) {
        this.payslipCollection.removeErrorPayslip(payslipRemoved);
        this.sendEventIfOnePayslipUploaded();
    }

    getDifferenceInMonths(dateA: Date, dateB: Date) {
        let months: number;
        months = (dateB.getFullYear() - dateA.getFullYear()) * 12;
        months -= dateA.getMonth();
        months += dateB.getMonth();
        return months <= 0 ? 0 : months;
    }
    
    loadGifs(...gifs: any[]) {
        for (var i = 0; i < gifs.length; i++) {
            this.gifs[i] = new Image();
            this.gifs[i].src = gifs[i];
        }
    }

    setClickedPeriod(yearAndMonth: number) {
        this.clickedPeriod = yearAndMonth;
    }

    sendEventIfOnePayslipUploaded() {
        if (this.payslipCollection.hasAtLeastOneUploadedPayslip()) {
            this.emitEvent("onePayslip", true);
        } else {
            this.emitEvent("onePayslip", false);
        }
    }

    emitEvent(event: string, body: any = false) {
        switch(event) {
            case "cobham":
                this.toCobhamEvent.emit(true);
                break;
            case "error":
                this.errorHandlingEvent.emit(body);
                break;
            case "loading":
                this.isLoadingEvent.emit(body);
                break;
            case "nextButton":
                this.isNextButtonEvent.emit(body);
                break;
            case "onePayslip" :
                this.hasAtLeastOnePayslipEvent.emit(body);
                break;
        }
    }

    updateStateDossier()
    {
        if (this.dossier.etatvalidation > 4) {
            this.appService.changeEtatValidationDossier(this.dossier.id, 4).subscribe((res) => {
                if (res.result) {
                    this.dossier = res.result.dossier;
                    this.setButtonsToPauseCobham.emit(true);
                }
                this.cdf.detectChanges();
            });
        }
    }
}
